import React, {useCallback, useContext, useEffect, useMemo, useReducer, useRef, useState} from 'react';
import clsx from "clsx";
import {Card, CardContent, CardHeader, Typography} from "@mui/material";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import useGetAllQuarantene from "../../../quarantene/utils/useGetAllQuarantene";
import {onClickDetails} from "../../../../../services/AutomationServices";
import {getAccountInfo} from "../../../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {AppContext} from "../../../../../App";
import {
	AUTOMATION_INITIAL_STATE,
	AutomationReducer,
	initAutomationState
} from "../../../../../reducers/AutomationReducer";
import {useHistory} from "react-router-dom";
import QuarantenaCard from "../../../quarantene/detail/QuarantenaCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';

const QuaranteneSection = ({idSoggetto}) => {
	const classes = BaseStyle();
	let history = useHistory();
	
	const [pageNumber, setPageNumber] = useState(0);
	const [selected, setSelected] = useState("");
	const appContext = useContext(AppContext);
	const soggettoSearch = useMemo(() => {
		return {idSoggetto: idSoggetto}
	}, [idSoggetto])
	
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const {
		loading,
		error,
		quarantene,
		hasMore
	} = useGetAllQuarantene("PAZIENTE", pageNumber, "", "", soggettoSearch, "", "", "ultimaModifica", "ASC")
	
	const observer = useRef();
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])
	
	const onClickQuarantena = (quarantena) => {
		setSelected(quarantena);
		onClickDetails(quarantena.idFocolaio, "focolaio", "modify", automationDispatch);
	}
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/focolai/" + selected.idFocolaio + "/soggetto/" + selected.soggetto.idSoggetto);
			} else {
				setOpenSnackbar("warning", ("L'ordinanza è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Quarantene paziente</b></Typography>}
					subheader={"Visualizza e gestisci le Autosorveglianze o Isolamenti del paziente"}
				/>
				<CardContent style={{flexGrow: 1, overflowY: "auto"}}>
					
					<div className={classes.content}
					     style={{maxHeight: "112vh", overflowY: "auto", overflowX: "hidden",}}>
						{
							quarantene.map((quarantena, index) => {
								if (quarantene.length === index + 1) {
									return (
										<Card ref={lastTicketElementRef} key={quarantena.id}
										      className={clsx(classes.roundBorder, classes.mailCard)}>
											<QuarantenaCard quarantena={quarantena} onclickQuarantena={onClickQuarantena}/>
										</Card>
									)
								} else {
									return (
										<Card key={quarantena.id} className={clsx(classes.roundBorder, classes.mailCard)}>
											<QuarantenaCard quarantena={quarantena} onclickQuarantena={onClickQuarantena}/>
										</Card>
									)
								}
							})
						}
						
						{!loading && !error && quarantene.length === 0 &&
							<Alert severity="info" style={{borderRadius: 24}}>
								<AlertTitle>Evvai 😇!!</AlertTitle>
								Non ci sono quarantene! Goditi questo meritato relax
							</Alert>}
						{!loading && error &&
							<Alert severity="error" style={{borderRadius: 24}}>
								<AlertTitle>Errore</AlertTitle>
								Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
								sviluppatori.
							</Alert>}
						{loading &&
							<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
								<CardHeader
									avatar={<Skeleton variant="circular" height={40} width={40}/>}
									title={<Skeleton width={180}/>}
									subheader={<Skeleton width={260}/>}
									action={<Skeleton variant="circular" height={20} width={20}/>}
									style={{paddingBottom: 2}}
								/>
								<CardContent style={{paddingTop: 0, marginTop: -35}}>
									<Skeleton height={200}/>
								</CardContent>
							</Card>}
					
					</div>
				
				
				</CardContent>
			</Card>
        </React.Fragment>
    );
};

export default React.memo(QuaranteneSection);
